import React from 'react';

const LegendaRegistro = () => {

    let styleNoteCard, styleUlElement = {};

    styleNoteCard = {
        width: '22px',
        height: '30px',
        borderRadius: '4px'
    };

    styleUlElement = {
        listStyleType: 'none',
        padding: '0px',
        marginLeft: '3px',
        display: 'flex',
        fontSize: '12px'
    };

    return (
        <div className='pt-3'>
            <ul style={styleUlElement}>
                <li className='flex-md-row'>
                    <div className='mx-auto bg-primary' style={styleNoteCard}>&nbsp;</div>
                    <p className='m-0 ml-2'>Info/Festivit&aacute;</p></li>
                <li className='flex-md-row'>
                    <div className='mx-auto bg-warning' style={styleNoteCard}>&nbsp;</div>
                    <p className='m-0 ml-2'>Attenzione</p></li>
                <li className='flex-md-row'>
                    <div className='mx-auto bg-danger' style={styleNoteCard}>&nbsp;</div>
                    <p className='m-0 ml-2'>Errore</p></li>
                <li className='flex-md-row'>
                    <div className='mx-auto bg-success' style={styleNoteCard}>&nbsp;</div>
                    <p className='m-0 ml-2'>Corretto/Giustificativo</p></li>
                <li className='flex-md-row'>
                    <div className='mx-auto bg-info' style={styleNoteCard}>&nbsp;</div>
                    <p className='m-0 ml-2'>Assenza Automatica Giustificata</p></li>
                <li className='flex-md-row'>
                    <div className='mx-auto bg-info text-white text-center'
                         style={{...styleNoteCard, lineHeight: '30px'}}>A</div>
                    <p className='m-0 ml-2'>Assenza intera giornata</p></li>
            </ul>
        </div>
    )
};

export default LegendaRegistro;
